import React from "react";

const ActionTooltip: React.FC<any> = ({ idx, deleteSubNode, addSubNode, moveNode, length, canAddContent }) => {
    return (
        <ul style={{
            position: "absolute",
            top: "0px",
            left: "-25px",
            backgroundColor: "white",
            padding: "6px",
            borderRadius: "3px",
            pointerEvents: "all",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
            zIndex: 9999,
        }}
            className="nodrag nopan">
            {
                length > 1 && (
                    idx !== 0 ?
                        <li className="action-icon hover-pad" onClick={() => moveNode('UP', idx)}><img src={require("../assets/node/arrow-up.png")} width={12} /></li>
                        : <li className="action-icon hover-pad" onClick={() => moveNode('DOWN', idx)}><img src={require("../assets/node/arrow-down.png")} width={12} /></li>)
            }
            {length > 1 && <li className="action-icon hover-pad"><img src={require("../assets/node/bin.png")} width={12} onClick={deleteSubNode} /></li>}
            {canAddContent && <li className="action-icon hover-pad"><img src={require("../assets/node/plus.png")} width={12} onClick={addSubNode} /></li>}
        </ul>
    )
}

export default ActionTooltip;
